<template>
    <div>
      <pre>{{debugText}}</pre>
    </div>
</template>

<script>
import { EventBus } from "../event-bus";

export default {
  data() {
    return {
      debug: false,
      step: 'eingabe',
      langs: ['de', 'en', 'es', 'fr'],
      username: 'nicht eingeloggt!',
      userdata: {},
      session: {},
      loginStatus: false,
      selected_project: 0,
      debugText: 'test'
    };
  },
  created: function () {
    console.log('Debug.vue created!');
    EventBus.$on('showDebug', (payload) => {
        //console.log('B debug....');
        //console.log(payload.debug);
        //console.log('E debug....');
        let str = JSON.stringify(payload.debug, undefined, 4);
        this.debugText = str;
        //dostuff
    });
  },
}
</script>
<style>

</style>